<template>
    <div>
        <el-form label-width='130px' label-position='left' v-if="electricInfo">
            <el-form-item label='电费缴纳方'>
                <div class="a-flex-rfsc">
                    <span class="a-flex-1">{{ electricInfo.companyName || '' }}</span>
                    <!-- <el-button type='primary' plain @click="handleToEdit">编辑</el-button> -->
                    <!-- <el-button type='primary' plain @click="handleChangeEleCompany">变更缴纳方</el-button> -->
                </div>
            </el-form-item>
            <el-form-item label='电费项目名称'>
                <span>{{ electricInfo.name || '' }}</span>
            </el-form-item>
            <el-form-item label='电费价格'>
                <span>{{ electricInfo.unitPrice || '' }}元/kwh</span>
            </el-form-item>
            <el-form-item label='电费收取方式'>
                <span>{{ electricInfo.chargeFeeType | initDic(chargeFeeTypeDic) }}</span>
            </el-form-item>
            <el-form-item label='电费收款方'>
                <span>{{ electricInfo.chargePayeeType | initDic(chargePayeeTypeDic) }}</span>
            </el-form-item>
            <el-form-item label='收款物业方' v-if="electricInfo.chargePayeeType == 2">
                <div class="a-flex-cfsfs">
                    <span v-for="(item, index) in electricInfo.propertyList" :key="index">{{ item.propertyName?item.propertyName:'-' }}，占比{{ item.rate }}%</span>
                </div>
            </el-form-item>
            <el-form-item label='默认服务费用'>
                <span>{{ electricInfo.serviceUnitPrice }}元</span>
            </el-form-item>
            <el-form-item label='账单默认备注'>
                <span>{{ electricInfo.remark || '-' }}</span>
            </el-form-item>
        </el-form>
        <el-empty description='暂无电费配置信息，点击按钮去配置' v-if="!electricInfo">
            <el-button type="primary" @click="dialogVisible = true">去配置</el-button>
        </el-empty>
        <el-dialog title="电费配置" :visible='dialogVisible' width='1200px'>
            <project-add-electric ref="electricForm" :changeEleCompany='changeEleCompany' :show-switch="false" :electricBillPayCompanyList="beneficiaryListComputed" :form.sync="electricForm"></project-add-electric>
            <div slot="footer">
                <el-button class="plainBtn" @click="dialogVisible = false">取消</el-button>
                <el-button type="primary"  @click="submit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import projectAddElectric from '@/views/project/project-add-electric'
export default {
    components: {
        projectAddElectric
    },
    data () {
        return {
            dialogVisible: false,
            changeEleCompany: false,//是否为变更缴纳方
            electricInfo: '',
            electricForm: {
                companyId: '',
                type: 1,
                useElectric: 1,
                name: '',
                electricFeeType: '1',
                chargeFeeType: '',//电费收取方式:1:预充值,2先用后付
                chargePayeeType: '',//电费收款方类型:1:App自交,2物业代收
                unitPrice: '',//电费单价
                serviceUnitPrice: '',//默认服务费
                propertyList: [],
                incomeIdList: [],
                remark: '',//账单默认备注
                electricFeeType: '1',
                projectId: '',//关联电费项目id
            },
            chargeFeeTypeDic: [],
            chargePayeeTypeDic: [],
            electricFeeTypeDic: []
        }
    },
    props: {
        projectId: {
            default: ''
        },
        incomeId: {
            default: ''
        },
        incomeName: {
            default: ''
        },
        beneficiaryList: {
            default: ()=>{
                return []
            }
        }
    },
    computed: {
        beneficiaryListComputed () {
            let list = []
            ;(this.beneficiaryList || []).forEach(item => {
                list.push({
                    ...item,
                    targetCompanyInfo: {
                        label: item.targetCompanyName,
                        value: item.targetCompanyId,
                    }
                })
                ;(item.childList || []).forEach(child => {
                    list.push({
                        ...child,
                        targetCompanyInfo: {
                            label: child.targetCompanyName,
                            value: child.targetCompanyId,
                        }
                    })
                })
            })
            return list
        }
    },
    watch: {
        projectId: {
            immediate: true,
            handler (val) {
                if(val) {
                    this.getPropertyDetail(val)
                }
            }
        }
    },
    mounted () {
        this.$getDic('chargeFeeType','select').then(res=>{ this.chargeFeeTypeDic = res; })
        this.$getDic('chargePayeeType','select').then(res=>{ this.chargePayeeTypeDic = res; })
        this.$getDic('electricFeeType','select').then(res=>{ this.electricFeeTypeDic = res; })
    },
    methods: {
        refresh () {
            if(this.projectId) {
                this.getPropertyDetail(this.projectId)
            }
        },
        getPropertyDetail (id) {
            this.$Axios._post({
                url: this.$Config.apiUrl.electricInfo,
                method: "post",
                params: {
                    id: id
                }
            })
            .then(res=>{
                if (res.result.code == 0) {
                    this.electricInfo = {
                        ...res.result.data,
                        chargeFeeType: JSON.stringify(res.result.data.chargeFeeType),//电费收取方式:1:预充值,2先用后付
                        chargePayeeType: JSON.stringify(res.result.data.chargePayeeType),//电费收款方类型:1:App自交,2物业代收
                        electricFeeType: JSON.stringify(res.result.data.electricFeeType),
                        unitPrice: res.result.data.unitPrice ? this.$decimal.decimal_except(res.result.data.unitPrice, 100) : '',//电费单价
                        serviceUnitPrice: res.result.data.serviceUnitPrice ? this.$decimal.decimal_except(res.result.data.serviceUnitPrice, 100) : '',//
                    }
                    this.electricInfo.propertyList = this.electricInfo.propertyList.map(item=>{
                        return {
                            ...item,
                            rate: Number((item.rate/100).toFixed(2))
                        }
                    })
                    
                    if(this.electricInfo.chargePayeeType == 2 && (!this.electricInfo.propertyList || !this.electricInfo.propertyList.length)) {
                        this.electricInfo.propertyList = []
                    }
                } else {
                    this.$message.error(res.result.message)
                }
            })
            .catch(err=>{
                console.log(err);
            })
        },
        async submit () {
            let validEle = await this.$refs['electricForm'].handleValidate()
            if(validEle) {
                if(this.changeEleCompany) {
                    let originCompanyInfo = this.beneficiaryListComputed.find(res=>{
                        return res.targetCompanyId == this.electricInfo.companyId
                    })
                    let targetCompanyInfo = this.beneficiaryListComputed.find(res=>{
                        return res.targetCompanyId == this.electricForm.companyId
                    })
                    this.$confirm(`“${originCompanyInfo.targetCompanyName}” 的电费项目将会复制和移交给 “${targetCompanyInfo.targetCompanyName}”，“${targetCompanyInfo.targetCompanyName}” 将可以录入电费账单，确认提交？`,'温馨提示')
                    .then(async _=>{
                        // 变更缴纳方
                        let result = await this.handleChangeEleCompanySubmit()
                        if(result) {
                            this.$message.success('电费缴纳方已变更')
                            this.getPropertyDetail(this.projectId)
                            this.dialogVisible = false
                        }else {
                            this.$message.error('电费缴纳方变更失败')
                        }
                    })
                    .catch(_=>{})
                } else if(this.electricForm.type == 1) {
                    this.electricForm.name = this.incomeName
                    this.electricForm.incomeIdList = [this.incomeId]
                    let result = await this.$refs['electricForm'].submit()
                    if(result) {
                        this.$message.success('电费项目创建成功')
                        // this.getPropertyDetail(this.projectId)
                        this.$emit('change')
                        this.dialogVisible = false
                    }else {
                        this.$message.error('电费项目创建失败')
                    }
                } else if(this.electricForm.type == 2) {
                    // 关联电费项目
                    let result = await this.handleBindEle()
                    if(result) {
                        this.$message.success('电费缴纳方已变更')
                        this.getPropertyDetail(this.electricForm.projectId)
                        this.dialogVisible = false
                    }else {
                        this.$message.error('电费缴纳方变更失败')
                    }
                }
            }
        },
        handleChangeEleCompanySubmit () {
            return new Promise ((resolve, reject)=>{
                this.$Axios._post({
                    url: this.$Config.apiUrl.electricChangeCompany,
                    method: "post",
                    params: {
                        "companyId": this.electricForm.companyId,
                        "incomeId": this.incomeId,
                        "projectId": this.projectId
                    }
                })
                .then(res=>{
                    if (res.result.code == 0) {
                        resolve(true)
                    } else {
                        resolve(false)
                    }
                })
                .catch(err=>{
                    resolve(false)
                })
            })
        },
        handleBindEle () {
            return new Promise ((resolve, reject)=>{
                this.$Axios._post({
                    url: this.$Config.apiUrl.incomeEleBind,
                    method: "post",
                    params: {
                        "incomeId": this.incomeId,
                        "projectId": this.electricForm.projectId
                    }
                })
                .then(res=>{
                    if (res.result.code == 0) {
                        resolve(true)
                    } else {
                        resolve(false)
                    }
                })
                .catch(err=>{
                    resolve(false)
                })
            })
        },
        handleToEdit () {
            this.$router.push({
                path: '/electric/electric-edit',
                query:{
                    id: this.projectId,
                }
            })
        },
        handleChangeConnect () {
            
        },
        handleChangeEleCompany () {
            this.changeEleCompany  = true
            this.dialogVisible = true
        }
    }
}
</script>

<style lang="scss" scoped>

</style>